import Poppy from "./poppy";

let __poppyHandler = {
    groups: {},
  
    info: function(message, group) {
        group = group || false;
        let notif = (new Poppy({
            position: "top center",
            duration: 7000,
            icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.2" d="M16.3403 1.9998H7.67031C4.28031 1.9998 2.00031 4.3798 2.00031 7.9198V16.0898C2.00031 19.6198 4.28031 21.9998 7.67031 21.9998H16.3403C19.7303 21.9998 22.0003 19.6198 22.0003 16.0898V7.9198C22.0003 4.3798 19.7303 1.9998 16.3403 1.9998Z" fill="#82C43C"/><path d="M10.8134 15.2479C10.5894 15.2479 10.3654 15.1629 10.1944 14.9919L7.82138 12.6189C7.47938 12.2769 7.47938 11.7229 7.82138 11.3819C8.16338 11.0399 8.71638 11.0389 9.05838 11.3809L10.8134 13.1359L14.9414 9.0079C15.2834 8.6659 15.8364 8.6659 16.1784 9.0079C16.5204 9.3499 16.5204 9.9039 16.1784 10.2459L11.4324 14.9919C11.2614 15.1629 11.0374 15.2479 10.8134 15.2479Z" fill="#82C43C"/></svg>',
            title: 'Başarılı',
            message: message
        }));
  
        if (group) {
            if (!this.groups[group]) {
                this.groups[group] = notif;
            }
  
            if (!this.groups[group].flags.isGenerated || this.groups[group].flags.hasDismissed) {
                this.groups[group].show();
            }
  
            this.groups[group].registerDismissal();
            this.groups[group].repositionAll();
  
            this.groups[group].message = message;
            this.groups[group].color = 'info';
        } else {
            notif.show();
        }
  
    },
    standard: function(message, group) {
        group = group || false;
        let notif = (new Poppy({
            position: "top center",
            duration: 7000,
            icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path opacity=".4" fill="#0062FF" d="M16.34 1.99H7.67C4.28 1.99 2 4.37 2 7.91v8.17c0 3.53 2.28 5.91 5.67 5.91h8.67c3.39 0 5.66-2.38 5.66-5.91V7.91c0-3.54-2.27-5.92-5.66-5.92Z"></path><path fill="#0062FF" fill-rule="evenodd" d="M11.12 8.18c0 .48.39.875.87.875 .49 0 .88-.4.88-.875 0-.49-.4-.875-.88-.875 -.49 0-.88.39-.88.875Zm1.74 3.17c0-.49-.4-.88-.88-.88 -.49 0-.875.39-.875.87v4.42c0 .48.39.87.875.87 .48 0 .87-.4.87-.88v-4.42Z"></path></svg>',
            title: 'Bilgilendirme',
            message: message,
            color: 'info',
        }));
  
        if (group) {
            if (!this.groups[group]) {
                this.groups[group] = notif;
            }
  
            if (!this.groups[group].flags.isGenerated || this.groups[group].flags.hasDismissed) {
                this.groups[group].show();
            }
  
            this.groups[group].registerDismissal();
            this.groups[group].repositionAll();
  
            this.groups[group].message = message;
            this.groups[group].color = 'standard';
        } else {
            notif.show();
        }
  
    },
    error: function(message, group) { 
        group = group || false;
        let notif = (new Poppy({
            position: "top center",
            duration: 7000,
            color: 'error',
            title: 'Hata',
            message: message,
            icon: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path opacity="0.2" d="M4.7227 21.1673C4.7097 21.1673 4.6977 21.1673 4.6837 21.1663C4.3687 21.1503 4.0597 21.0823 3.7657 20.9633C2.3187 20.3753 1.6207 18.7223 2.2077 17.2763L9.5287 4.4503C9.7807 3.9943 10.1627 3.6123 10.6287 3.3543C11.9937 2.5983 13.7197 3.0953 14.4747 4.4593L21.7477 17.1873C21.9097 17.5683 21.9787 17.8783 21.9957 18.1943C22.0347 18.9503 21.7767 19.6753 21.2707 20.2363C20.7647 20.7973 20.0697 21.1283 19.3147 21.1663L4.7947 21.1673H4.7227Z" fill="#FC5A5A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.1245 10.0208C11.1245 9.5388 11.5175 9.1458 11.9995 9.1458C12.4815 9.1458 12.8745 9.5388 12.8745 10.0208V12.8488C12.8745 13.3318 12.4815 13.7238 11.9995 13.7238C11.5175 13.7238 11.1245 13.3318 11.1245 12.8488V10.0208ZM11.1245 16.2699C11.1245 15.7849 11.5175 15.3899 11.9995 15.3899C12.4815 15.3899 12.8745 15.7799 12.8745 16.2589C12.8745 16.7519 12.4815 17.1449 11.9995 17.1449C11.5175 17.1449 11.1245 16.7519 11.1245 16.2699Z" fill="#FC5A5A"/></svg>'
        }));
  
        if (group) {
            if (!this.groups[group]) {
                this.groups[group] = notif;
            }
            
            if (!this.groups[group].flags.isGenerated || this.groups[group].flags.hasDismissed) {
                this.groups[group].show();
            }
  
            this.groups[group].registerDismissal();
            this.groups[group].repositionAll();
  
            this.groups[group].message = message;
            this.groups[group].color = 'error';
        } else {
            notif.show();
        }
    }
  }

  export default __poppyHandler;